<template>
  <div class="home-page">
    <div class="home-banner">
      <GsSkeleton v-if="bannerLoading" variant="banner" />
      <Banner v-else class="hero-banner" :isShow="false" :images="carouselImages"></Banner>
    </div>

    <div class="home-main">
      <div class="home-zone home-zone-upper" :class="{ 'is-announce-fixed': isCarouselFixed }">
        <div class="shujufuwushang">
          <dataInfoLeft/>
        </div>
        <div class="carousel-slot" ref="announceSlot" :style="announceSlotStyle">
          <div
            class="carousel-container"
            :class="{ 'fixed-carousel': isCarouselFixed }"
            :style="fixedAnnounceStyle"
          >
            <carousel/>
          </div>
        </div>
        <div class="bg-white first-center br display-flex home-block-activity">
          <div class="center-content">
            <GsSkeleton v-if="hostLoading" :rows="5" />
            <Banner v-else class="news-banner gs-card" :images="hostNewList"></Banner>
          </div>
          <div class="right-content">
            <twentyFourNew/>
          </div>
        </div>
        <div class="mt20 home-block-resources">
          <!-- <LiveInfo/> -->
          <DataChange/>
        </div>
      </div>

      <div class="home-zone home-zone-plain home-block-resources">
        <div class="news mt20">
          <div class="news-content">
            <div class="news-conter-left">
              <GsSkeleton v-if="newsLoading" :rows="6" />
              <newsDetail v-else :newsDetailData="newsDetailData"></newsDetail>
            </div>
            <div class="news-conter-right">
              <userDetail :userDetailData="userDetailData"></userDetail>
              <Interview class="mt20" />
            </div>
          </div>
        </div>
        <div class="mt20">
          <IndustryInfo />
        </div>
      </div>

      <div class="home-zone home-zone-map home-block-map" ref="mapSlot">
        <component :is="mapComp" v-if="mapComp" />
        <GsSkeleton v-else variant="map" />
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "./components/carousel/index";
import carousel1 from "./components/carousel/index1";
import Banner from "./components/Banner";
import newsDetail from "../../components/NewsDetail";
import twentyFourNew from "../../components/24HNew";
import userDetail from "../../components/UserDetail";
import Interview from "@/components/Interview";
// import LiveInfo from "../../components/LiveInfo";
import DataChange from "../../components/DataChange";
import ZcFileInfo from "@/components/ZcFileInfo";
import IndustryInfo from '../../components/IndustryInfo';
import dataInfoLeft from "@/views/Home/components/dataInfo/dataInfoLeft.vue";
import ContactInfo from '@/components/ContactInfo'
import HomeIndex from '@/views/Home/Breadcrumb.vue'
import { P } from '@/router/paths'
import {
  getNewsList,
  getHomeShowcase
} from "@/api/api";

/** home_showcase.image 可能已经带 /xwzx 前缀，统一成相对路径，交给 Banner 组件拼 prodUrl */
function normalizeShowcaseImage(raw) {
  if (!raw) return ''
  if (/^https?:\/\//i.test(raw)) return raw
  return raw.replace(/^\/?xwzx\//, '/')
}

export default {
  data() {
    return {
      carouselImages: [],
      twentyFourNewList:[],
      hostNewList:[],
      newsDetailData:[],
      newsDetailData2:[],
      userDetailData:[],
      prodUrl:"https://shujuzichan.com/xwzx",
      isCarouselFixed: false,
      scrollTop: 0,
      headerH: 72,
      announceH: 44,
      bannerLoading: true,
      hostLoading: true,
      newsLoading: true,
      mapComp: null
    };
  },
  components: {
    carousel,
    twentyFourNew,
    carousel1,
    Banner,
    newsDetail,
    // LiveInfo,
    userDetail,
    Interview,
    ZcFileInfo,
    dataInfoLeft,
    DataChange,
    IndustryInfo,
    ContactInfo,
    HomeIndex
  },
  computed: {
    isShowHome() {
      return this.$store.getters.showIndexMethod
    },
    announceSlotStyle() {
      return this.isCarouselFixed && this.announceH
        ? { height: this.announceH + 'px' }
        : null
    },
    fixedAnnounceStyle() {
      return this.isCarouselFixed
        ? { top: this.headerH + 'px' }
        : null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll();
      this.observeMap();
    });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this._mapIo) this._mapIo.disconnect();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this._mapIo) this._mapIo.disconnect();
  },
  created() {
    this.getSyLbNewList();
    this.getHostNewList();
    this.getNewList();
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (window.innerWidth < 960) {
        this.isCarouselFixed = false
        return
      }
      const header = document.querySelector('.gs-header')
      this.headerH = header ? header.offsetHeight : 72
      const slot = this.$refs.announceSlot
      if (!slot) return
      if (!this.isCarouselFixed) {
        this.announceH = slot.offsetHeight
      }
      this.isCarouselFixed = slot.getBoundingClientRect().top <= this.headerH
    },
    moreClick() {
      this.$router.push(P.news)
    },
    observeMap() {
      const el = this.$refs.mapSlot
      const load = () => {
        if (this.mapComp) return
        import('@/components/ChinaMap/index.vue').then((mod) => {
          this.mapComp = mod.default
        }).catch(() => {})
      }
      if (!el || typeof IntersectionObserver === 'undefined') {
        load()
        return
      }
      this._mapIo = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          load()
          this._mapIo.disconnect()
        }
      }, { rootMargin: '280px' })
      this._mapIo.observe(el)
    },

    getNewList () {
      getNewsList({
        pageNum: 1,
        pageSize: 12,
        type: 2,
        whetherPublish: '1'
      }).then((response) => {
        this.newsDetailData = response.rows || [];
      }).finally(() => {
        this.newsLoading = false
      });
    },
    getSyLbNewList () {
      // 首页大横幅现在由后台「首页横幅」维护；接口没数据时回退到旧的资讯 newest=0
      getHomeShowcase({ section: 'banner' }).then((res) => {
        const rows = (res && res.data) || []
        if (rows.length) {
          this.carouselImages = rows.map((item) => ({
            id: item.id,
            homePicture: normalizeShowcaseImage(item.image),
            chineseTitle: item.title,
            linkUrl: item.linkUrl || '',
          }))
          this.bannerLoading = false
          return
        }
        this.fallbackBannerNews()
      }).catch(() => {
        this.fallbackBannerNews()
      })
    },
    fallbackBannerNews () {
      getNewsList({
        pageNum: 1,
        pageSize: 1,
        newest: 0,
        whetherPublish: '1'
      }).then((response) => {
        this.carouselImages = response.rows || []
      }).finally(() => {
        this.bannerLoading = false
      })
    },
    getHostNewList () {
      // 24H新刊速递左侧活动同样改由后台「活动」维护，空则回退旧的 newest=3
      getHomeShowcase({ section: 'activity' }).then((res) => {
        const rows = (res && res.data) || []
        if (rows.length) {
          this.hostNewList = rows.map((item) => ({
            id: item.id,
            homePicture: normalizeShowcaseImage(item.image),
            chineseTitle: item.title,
            linkUrl: item.linkUrl || '',
          }))
          this.hostLoading = false
          return
        }
        this.fallbackHostNews()
      }).catch(() => {
        this.fallbackHostNews()
      })
    },
    fallbackHostNews () {
      getNewsList({
        pageNum: 1,
        pageSize: 5,
        newest: 3,
        whetherPublish: '1'
      }).then((response) => {
        this.hostNewList = response.rows || []
      }).finally(() => {
        this.hostLoading = false
      })
    }

  }
};
</script>

<style scoped>
.home-page {
  --home-overlap: 140px;
  position: relative;
  width: 100%;
  background: transparent;
}
.home-banner {
  position: relative;
  z-index: 1;
  width: 100%;
}
.home-banner :deep(.carousel),
.home-banner :deep(.el-carousel),
.home-banner :deep(.el-carousel__container) {
  width: 100%;
}
.home-banner :deep(.el-carousel__item img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.home-main {
  position: relative;
  z-index: 2;
  /* 首页主区宽度统一由 --gs-home-width 控制 */
  width: min(var(--gs-home-width, 1300px), calc(100% - 32px));
  margin: calc(var(--home-overlap) * -1) auto 0;
}
.home-zone {
  position: relative;
  isolation: isolate;
}
.home-zone::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  z-index: -1;
  pointer-events: none;
}
.home-zone-upper {
  padding-bottom: 28px;
}
.home-zone-upper::before {
  top: var(--home-overlap);
  background-color: #E8F1FB;
  background-image:
    linear-gradient(135deg, rgba(255,255,255,0.7) 0 42%, transparent 42%),
    linear-gradient(225deg, rgba(255,255,255,0.45) 0 30%, transparent 30%),
    url('@/assets/images/编组 65@2x.png');
  background-repeat: no-repeat;
  background-position: left 8% bottom, right 6% top, center;
  background-size: 320px 200px, 260px 160px, cover;
}
.home-zone-plain {
  padding-bottom: 20px;
}
.home-zone-plain::before {
  background: transparent;
}
.home-zone-map {
  padding-top: 12px;
}
.home-zone-map::before {
  background-color: #D7E7F8;
  background-image: url('@/assets/images/编组 65@2x.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.first-center {
  padding: 12px;
}
.center-content {
  width: 67%;
  margin-right: 10px;
}
.right-content {
  width: 33%;
  height: 100%;
  background: linear-gradient( 180deg, #E4EFFF 0%, #FFFFFF 100%);
  border-radius: 8px;
  padding: 12px;
}
.news-content{
  display: flex;
  align-items: flex-start;
}
.news-conter-left{
  width: 67%;
  height: auto;
}
.news-conter-right {
  width: 33%;
  height: auto;
  margin-left: 10px;
}
.hover-red:hover {
  color: #ff0000;
}
.carousel-slot {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 16px 0 18px;
}
.carousel-container {
  width: 100%;
  min-height: 44px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(17, 24, 36, 0.06);
  transition: box-shadow 0.25s ease, padding 0.25s ease;
}
.home-zone-upper.is-announce-fixed {
  z-index: 40;
}
.fixed-carousel {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 80;
  width: min(var(--gs-home-width, 1300px), calc(100% - 32px));
  padding: 8px 12px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(17, 24, 36, 0.12);
  border-radius: 0 0 8px 8px;
}
@media (max-width: 960px) {
  .home-page {
    --home-overlap: 56px;
    --home-pad: 10px;
  }
  .home-page,
  .home-main {
    max-width: 100%;
    overflow-x: clip;
  }
  .home-banner {
    width: 100%;
  }
  .home-main {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 0 var(--home-pad);
    box-sizing: border-box;
  }
  .home-zone-upper::before {
    background-size: 160px 100px, 120px 80px, cover;
  }
  .shujufuwushang {
    margin: 0 calc(var(--home-pad) * -1) 8px;
    padding: 0;
  }
  :deep(.hero-banner) {
    position: relative;
    z-index: 1;
  }
  .home-block-activity {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    overflow: visible;
    border-radius: 0;
    background: transparent !important;
  }
  .first-center {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    overflow: visible;
    border-radius: 0;
    background: transparent !important;
    box-shadow: none;
  }
  .center-content,
  .right-content {
    width: 100%;
    margin-right: 0;
    box-sizing: border-box;
    max-width: 100%;
  }
  .center-content {
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
  }
  .right-content {
    margin-top: 0;
    padding: 10px;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 8px rgba(17, 24, 36, 0.06);
  }
  .news-content {
    flex-direction: column;
    gap: 12px;
  }
  .news-conter-left,
  .news-conter-right {
    width: 100%;
    margin-left: 0;
    max-width: 100%;
    box-sizing: border-box;
  }
  .news-conter-right {
    margin-top: 0;
  }
  .carousel-slot {
    position: sticky;
    top: var(--gs-header-h, 44px);
    z-index: 80;
    margin: 8px 0 10px;
  }
  .home-zone-upper {
    padding-bottom: 18px;
  }
  .home-zone-plain {
    padding-bottom: 8px;
  }
  .home-zone-map {
    padding-top: 4px;
  }
  :deep(.industry-block) {
    padding-bottom: 8px;
  }
  .carousel-container {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(17, 24, 36, 0.1);
  }
  .fixed-carousel {
    position: static !important;
    left: auto !important;
    transform: none !important;
    width: 100% !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
  .home-block-map {
    margin: 0 calc(var(--home-pad) * -1);
    padding-left: var(--home-pad);
    padding-right: var(--home-pad);
  }
  .mt20 {
    margin-top: 14px;
  }
}
</style>